"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardsNotShownProvider = exports.CARD_BUILD_SOURCE = void 0;
exports.cardsNotShownAfter = cardsNotShownAfter;
exports.useCardsNotShown = useCardsNotShown;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CARD_BUILD_SOURCE = exports.CARD_BUILD_SOURCE = "card_build";
var NO_CARDS_NOT_SHOWN = {
  markNotShownFrom: function markNotShownFrom() {
    return undefined;
  },
  reasonOf: function reasonOf() {
    return undefined;
  }
};
var CardsNotShownContext = /*#__PURE__*/(0, _react.createContext)(NO_CARDS_NOT_SHOWN);
function cardsNotShownAfter(previous, conversationId, source, actionIds, reason) {
  var previousByAction = previous.get(conversationId);
  var changes = actionIds.some(function (actionId) {
    var _previousByAction$get, _previousByAction$get2;
    return ((_previousByAction$get = previousByAction === null || previousByAction === void 0 || (_previousByAction$get2 = previousByAction.get(actionId)) === null || _previousByAction$get2 === void 0 ? void 0 : _previousByAction$get2.get(source)) !== null && _previousByAction$get !== void 0 ? _previousByAction$get : null) !== reason;
  });
  if (!changes) return previous;
  var nextByAction = new Map(previousByAction);
  var _iterator = _createForOfIteratorHelper(actionIds),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _actionId = _step.value;
      var reasonBySource = new Map(nextByAction.get(_actionId));
      if (reason === null) reasonBySource.delete(source);else reasonBySource.set(source, reason);
      if (reasonBySource.size === 0) nextByAction.delete(_actionId);else nextByAction.set(_actionId, reasonBySource);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var next = new Map(previous);
  if (nextByAction.size === 0) next.delete(conversationId);else next.set(conversationId, nextByAction);
  return next;
}
var CardsNotShownProvider = exports.CardsNotShownProvider = function CardsNotShownProvider(_ref) {
  var conversationId = _ref.conversationId,
    children = _ref.children;
  var _useState = (0, _react.useState)(new Map()),
    _useState2 = _slicedToArray(_useState, 2),
    cardsNotShown = _useState2[0],
    setCardsNotShown = _useState2[1];
  var markNotShownFrom = (0, _react.useCallback)(function (source, actionIds, reason) {
    if (conversationId === undefined) return;
    setCardsNotShown(function (previous) {
      return cardsNotShownAfter(previous, conversationId, source, actionIds, reason);
    });
  }, [conversationId]);
  var reasonOf = (0, _react.useCallback)(function (actionId, exceptSource) {
    var _cardsNotShown$get$ge, _cardsNotShown$get;
    if (conversationId === undefined) return undefined;
    var reasonBySource = (_cardsNotShown$get$ge = (_cardsNotShown$get = cardsNotShown.get(conversationId)) === null || _cardsNotShown$get === void 0 ? void 0 : _cardsNotShown$get.get(actionId)) !== null && _cardsNotShown$get$ge !== void 0 ? _cardsNotShown$get$ge : new Map();
    var _iterator2 = _createForOfIteratorHelper(reasonBySource),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          _source = _step2$value[0],
          _reason = _step2$value[1];
        if (_source !== exceptSource) return _reason;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return undefined;
  }, [conversationId, cardsNotShown]);
  var value = (0, _react.useMemo)(function () {
    return {
      markNotShownFrom: markNotShownFrom,
      reasonOf: reasonOf
    };
  }, [markNotShownFrom, reasonOf]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CardsNotShownContext.Provider, {
    value: value,
    "data-sentry-element": "CardsNotShownContext.Provider",
    "data-sentry-component": "CardsNotShownProvider",
    "data-sentry-source-file": "CardsNotShownContext.tsx",
    children: children
  });
};
function useCardsNotShown(source) {
  var _useContext = (0, _react.useContext)(CardsNotShownContext),
    markNotShownFrom = _useContext.markNotShownFrom,
    reasonOf = _useContext.reasonOf;
  var markNotShown = (0, _react.useCallback)(function (actionIds, reason) {
    return markNotShownFrom(source, actionIds, reason);
  }, [markNotShownFrom, source]);
  return (0, _react.useMemo)(function () {
    return {
      markNotShown: markNotShown,
      reasonOf: reasonOf
    };
  }, [markNotShown, reasonOf]);
}